import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FolderRequestDto } from 'src/api/FiretrolApiClient';
import { documentApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateFolder(jobId: number | null | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: FolderRequestDto) =>
      documentApiClient.createFolder(jobId!, request),
    // The dialog renders its own field-level errors.
    meta: { suppressErrorToast: true, errorContext: 'create folder' },
    onSettled: () => invalidateFor('folder.write', qc, { jobId: jobId! }),
  });
}

export function useUpdateFolder(jobId: number | null | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      folderId,
      request,
    }: {
      folderId: string;
      request: FolderRequestDto;
    }) => documentApiClient.updateFolder(jobId!, folderId, request),
    meta: { suppressErrorToast: true, errorContext: 'update folder' },
    onSettled: () => invalidateFor('folder.write', qc, { jobId: jobId! }),
  });
}

export function useDeleteFolder(jobId: number | null | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (folderId: string) =>
      documentApiClient.removeFolder(jobId!, folderId),
    meta: { successMessage: 'Folder removed!' },
    onSettled: () => invalidateFor('folder.write', qc, { jobId: jobId! }),
  });
}
